import { LoadedFile } from "../../pit-shared/domain/loaded-file";
import { HttpHeaders } from "@angular/common/http";
import { DxHttpDispatcher } from "../../dx-core/services/dx-http-dispatcher.service";
import { fromPromise } from "rxjs/internal-compatibility";
import { BdpkConfigService } from "./bdpk-config.service";
import { DxObjectMapper } from "../../dx-core/services/dx-object-mapper.service";
import { BdpkApiInfo } from "../domain/bdpk-api-info";
import { map, take } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./bdpk-config.service";
import * as i2 from "../../dx-core/services/dx-object-mapper.service";
import * as i3 from "../../dx-core/services/dx-http-dispatcher.service";
export class BdpkFileService {
    constructor(_configService, _mapper, _http) {
        this._configService = _configService;
        this._mapper = _mapper;
        this._http = _http;
        this.options = {
            headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
            observe: 'response',
            withCredentials: true
        };
    }
    uploadFile(blob, fileName) {
        const promise = new Promise((resolve, reject) => {
            const path = this._configService.bdpkFileStorageService + '/files';
            const headers = new HttpHeaders();
            let formData = new FormData();
            formData.append('file', blob, fileName);
            this._http
                .post(path, formData, { headers: headers, observe: 'response' })
                .subscribe(response => {
                resolve(this._mapper.deserialize(response.body, LoadedFile));
            }, errorResponse => {
                reject(DxHttpDispatcher.handleHttpError(errorResponse));
            });
        });
        return fromPromise(promise);
    }
    downloadFile(id) {
        const path = this._configService.bdpkFileStorageService + '/files/' + id;
        window.location.href = path;
    }
    /**
     * метод, который нужен только для определения git commit всего backend-а.
     */
    info() {
        return this._http
            .get(this._configService.bdpkFileStorageService + '/info', this.options)
            .pipe(take(1), map(response => {
            return this._mapper.deserialize(response.body, BdpkApiInfo);
        }));
    }
}
BdpkFileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BdpkFileService_Factory() { return new BdpkFileService(i0.ɵɵinject(i1.BdpkConfigService), i0.ɵɵinject(i2.DxObjectMapper), i0.ɵɵinject(i3.DxHttpDispatcher)); }, token: BdpkFileService, providedIn: "root" });
